import script from "./BaseProdDialog.vue?vue&type=script&setup=true&name=BaseProdDialog&lang=js"
export * from "./BaseProdDialog.vue?vue&type=script&setup=true&name=BaseProdDialog&lang=js"

const __exports__ = script;

export default __exports__